import { createContext } from 'react';
import type { API } from '@trinity/chat';

// Map of brand identifier to applications for that brand
export const UserApplicationsContext = createContext<Record<string, API.App.UserApplication[]>>({});

// Currently active application identifier
export const ActiveApplicationContext = createContext<string | null>(null);

// Setter for active application
export const SetActiveApplicationContext = createContext<React.Dispatch<React.SetStateAction<string | null>>>(null);
